import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "text-lg font-semibold text-gray-900 flex items-center" };
const _hoisted_2 = { class: "ml-auto flex items-center" };
const _hoisted_3 = { class: "mt-2" };
const _hoisted_4 = {
    key: 0,
    class: "space-y-2"
};
const _hoisted_5 = { class: "flex items-center text-sm" };
const _hoisted_6 = { class: "text-gray-700" };
const _hoisted_7 = { class: "flex items-center text-sm" };
const _hoisted_8 = { class: "text-gray-700" };
const _hoisted_9 = {
    key: 0,
    class: "flex items-center text-sm"
};
const _hoisted_10 = { class: "text-gray-700" };
const _hoisted_11 = {
    key: 1,
    class: "text-gray-500 text-sm"
};
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerDataForm',
    props: {
        modelValue: {}
    },
    emits: ["openModal"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isComplete = computed(() => {
            return (props.modelValue.name.trim().length > 0 &&
                props.modelValue.email.trim().length > 0 &&
                props.modelValue.email.includes("@"));
        });
        function openModal() {
            emit("openModal");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "bg-white px-8 pt-4 pb-2 cursor-pointer",
                onClick: openModal
            }, [
                _createElementVNode("h3", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createTextVNode(" Kontaktdaten ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_2, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-edit text-gray-400 text-sm mr-2" }, null, -1 /* CACHED */)),
                        _createElementVNode("div", {
                            class: _normalizeClass(['w-2 h-2 rounded-full', isComplete.value ? 'bg-green-500' : 'bg-gray-400'])
                        }, null, 2 /* CLASS */)
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (isComplete.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-user text-gray-400 w-4 mr-3" }, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.modelValue.name), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-envelope text-gray-400 w-4 mr-3" }, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.modelValue.email), 1 /* TEXT */)
                            ]),
                            (_ctx.modelValue.phone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-phone text-gray-400 w-4 mr-3" }, null, -1 /* CACHED */)),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.modelValue.phone), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("div", { class: "contact-hint-desktop" }, [
                                    _createElementVNode("i", { class: "fas fa-plus-circle mr-2" }),
                                    _createTextVNode(" Klicke hier, um die Kontaktdaten hinzuzufügen")
                                ], -1 /* CACHED */),
                                _createElementVNode("div", { class: "contact-hint-mobile" }, [
                                    _createElementVNode("i", { class: "fas fa-plus-circle mr-2" }),
                                    _createTextVNode(" Tippe hier, um die Kontaktdaten hinzuzufügen")
                                ], -1 /* CACHED */)
                            ]))]))
                ])
            ]));
        };
    }
});
